export default {
  dataIterator: {
    rowsPerPageText: 'Elements per pàgina:',
    rowsPerPageAll: 'Tot',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Sense dades per mostrar',
    nextPage: 'Pàgina Següent',
    prevPage: 'Pàgina Anterior'
  },
  dataTable: {
    rowsPerPageText: 'Files per pàgina:'
  },
  noDataText: 'Sense dades',
  carousel: {
    prev: 'Visualització prèvia',
    next: 'Següent visual'
  }
}
